import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormControl} from "@angular/forms";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

import { ActivityModelNew } from "../models/newChanges/activityModelNew";
import { CommonActivityService } from "../service/common-activity.service";
import { CustomModalPopupComponent } from "../custom-modal-popup/custom-modal-popup.component";
import { GSFReport } from "../GSF-report.service";
import { WasteReductionService } from "../wasteReduction/service/waste-reduction.service";
import { constants } from "../constants/constants";

@Component({
  selector: "app-toggle",
  templateUrl: "./toggle.component.html",
  styleUrls: ["./toggle.component.css"]
})
export class ToggleComponent implements OnInit {
  @Input()
  activity: ActivityModelNew;
  @Input()
  activityIndex: any;
  @Input()
  pillarName: string;
  @Input()
  toggleFlagCtl: UntypedFormControl;

  @Output() errorInToggle: EventEmitter<string> = new EventEmitter();
  private readonly snackBarDuration = constants.DURATION;
  selectedlang: string;
  private hasInfo: boolean = false;

  constructor(
    public commActService: CommonActivityService,
    private readonly dialog: MatDialog,
    private readonly report: GSFReport,
    private readonly snackBar: MatSnackBar,
    private readonly translate: TranslateService,
    private readonly wasteReductionService: WasteReductionService
  ) {
    this.translate = translate;
    translate.setDefaultLang(constants.LANGUAGE);
    this.selectedlang = constants.LANGUAGE;
  }

  ngOnInit() {
    this.activity.toggleFlag = false;
  }

  dispActivities(event: any): void {
    if (event.target.checked && this.activity.showWarning && !this.activity.hasInfo) {
      this.openWarningDialog(
        this.activity.warningMessage ? this.activity.warningMessage : "", this.hasInfo
        );
      }
      if (event.target.checked && this.activity.showWarning && !this.activity.hasDependency && this.activity.hasInfo) {
        this.hasInfo = this.activity.hasInfo;
        this.openWarningDialog(
          this.activity.warningMessage ? this.activity.warningMessage : "", this.hasInfo
      );
    }
    this.updateToggle();

    if (this.activity.qusType === constants.TYPE) {
      this.updateWasteRedObj();
    }
  }
  private openWarningDialog(label: string, info: boolean): Observable<boolean> {
    const dialogRef = this.dialog.open(CustomModalPopupComponent, {
      data: { label, info }
    });
    return dialogRef.afterClosed();
  }


  private addDeleteStatus(questionList: any): void {
    questionList.forEach(question => {
      question.status = constants.DELETE;
    });
  }

  private addModifiedStatus(questionList: any): void {
    questionList.forEach((question, index) => {
      if (question.status === "") {
        question.status = constants.CREATE;
      } else if (question.status === constants.DELETE && index === 0) {
        if (question.reportDetailGSFId) {
          question.status = constants.UPDATE;
        } else {
          question.status = constants.CREATE;
        }
      }
    });
  }

  private openSnackBar(message: string, time: any): void {
    this.snackBar.open(message, constants.ACTION, {
      duration: time
    });
  }

  private toggleFalseMethod(): void {
    this.activity.status = constants.DELETE;
    this.addDeleteStatus(this.activity.questionList);

  }

  private toggleTrueMethod(): void {
    this.activity.status = constants.MODIFIED;
    this.addModifiedStatus(this.activity.questionList);

  }



  private updateToggle(): void {
    this.toggleFlagCtl.markAsTouched();
    this.activity.toggleFlag = !this.activity.toggleFlag;
    if (this.activity.toggleFlag) {
      this.toggleTrueMethod();
    } else {
      this.toggleFalseMethod();
      this.report.gsfValid = true;
    }
  }

  private updateWasteRedObj(): void {
    const wasteConfigJson = this.wasteReductionService.getTableConfigQus(this.activity.id);
    if (this.activity.toggleFlag) {
      const tableKeys = Object.keys(wasteConfigJson);
      tableKeys.forEach(key => {
        wasteConfigJson[key].status = wasteConfigJson[key].reportDetailGSFId
          ? constants.MODIFIED
          : constants.CREATE;
      });
    } else {
      const tableKeys = Object.keys(wasteConfigJson);
      tableKeys.forEach(key => {
        wasteConfigJson[key].status = constants.MODIFIED;
      });
    }
  }
}
